import { WateringCanIcon } from './WateringCanIcon';

/**
 * author: guenth39
 * id 5B017D32-0BE9-4A6A-999C-32777F995FBB
 * name watering-can
 * version: 5.3.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/watering-can.svg
 * tags
 * - Agriculture 
 */
export const WateringPotIcon = WateringCanIcon;
export default WateringPotIcon